import capitalize from 'lodash/capitalize'
import isEmpty from 'lodash/isEmpty'
import { getFreeTrialPropertiesAsync } from '../../../lib'
import { Advocate } from '../../../lib/types'
import i18nInstance from '../../i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, '@mc/guest-pass')

const checkAdvocateName = (name?: string) => {
  if (!name || !name?.trim())
    return t('recipientPage.friendName', { ns: '@mc/guest-pass' })

  return capitalize(name)
}

// Used in pre-paywall: a recipient can know the advocate's info (who sent the guest pass)
export const getGuestPassAdvocatePropertiesAsync = async (refresh = false) => {
  const { advocate } = await getFreeTrialPropertiesAsync(refresh)

  if (!advocate || isEmpty(advocate)) return null

  const {
    name,
    profileImg = '',
    ...data
  } = advocate as Advocate & { profileImg?: string }

  return {
    name: checkAdvocateName(name),
    profileImg: !profileImg.includes('default-avatar') ? profileImg : undefined,
    ...data,
  }
}
